/* eslint-disable */
import React, { useState } from "react";
import { Modal, Upload, Button, message, Spin, Typography } from "antd";
import { CloudUploadOutlined, DownloadOutlined, FileTextOutlined } from "@ant-design/icons";
import axios from "axios";
import urls from "../../api/urls"; // Adjust path as needed
import { getToken } from "../../utils/worker";
import { getUserAndPremiseId } from "../../utils";

const { Dragger } = Upload;

const BulkTrackingModal = ({ open, onClose }) => {
    const [fileList, setFileList] = useState([]);
    const [loading, setLoading] = useState(false);

    // You can define a sample file URL here if needed, or pass it as a prop
    const SAMPLE_FILE_URL = "";
    const SAMPLE_FILE = require("../../assests/documents/SampleBuilkTracking.csv");

    const handleUpload = async () => {
        if (fileList.length === 0) {
            message.warning("Please select a file to upload.");
            return;
        }

        const file = fileList[0];
        const formData = new FormData();
        formData.append("file", file);
        formData.append("format", "csv");

        const token = getToken();
        // const userInfo = getUserAndPremiseId();

        setLoading(true);

        try {
            const response = await axios.post(urls.BULK_TRACKING_UPLOAD, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                responseType: "blob", // Important for downloading the file
            });

            // Create a blob link to download
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;

            const fileName = "bulk_tracking_response.csv";

            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();

            message.success("File processed and downloaded successfully!");
            setFileList([]);
            onClose();
        } catch (error) {
            console.error("Upload error:", error);
            let errorMsg = "Upload failed.";
            if (error.response && error.response.data instanceof Blob) {
                // If error is blob, try to read it
                const reader = new FileReader();
                reader.onload = () => {
                    try {
                        const errObj = JSON.parse(reader.result);
                        message.error(errObj.message || errorMsg);
                    } catch (e) {
                        message.error(errorMsg);
                    }
                }
                reader.readAsText(error.response.data);
            } else {
                message.error(error?.response?.data?.message || errorMsg);
            }
        } finally {
            setLoading(false);
        }
    };

    const props = {
        onRemove: (file) => {
            setFileList((prev) => {
                const index = prev.indexOf(file);
                const newFileList = prev.slice();
                newFileList.splice(index, 1);
                return newFileList;
            });
        },
        beforeUpload: (file) => {
            const isCsvOrExcel =
                file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                file.type === "application/vnd.ms-excel" ||
                file.name.endsWith('.csv') ||
                file.name.endsWith('.xlsx');

            if (!isCsvOrExcel) {
                message.error(`${file.name} is not a valid excel or csv file`);
                return Upload.LIST_IGNORE;
            }

            setFileList([file]); // Allow only one file
            return false; // Prevent automatic upload
        },
        fileList,
    };

    return (
        <Modal
            title={
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <CloudUploadOutlined style={{ color: '#1890ff', fontSize: '20px' }} />
                    <span>Bulk Tracking Upload</span>
                </div>
            }
            open={open}
            onCancel={onClose}
            width={600}
            centered
            footer={[
                <Button
                    key="upload"
                    type="primary"
                    onClick={handleUpload}
                    loading={loading}
                    disabled={fileList.length === 0}
                    style={{ borderRadius: '6px', background: '#1890ff', borderColor: '#1890ff' }}
                >
                    Upload & Process
                </Button>,
            ]}
            className="bulk-tracking-modal"
        >
            <div style={{ marginBottom: 24 }}>
                <Typography.Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
                    Upload your tracking file (.csv or .xlsx) to check shipment status in bulk. The system will process your file and automatically download the latest status report.
                </Typography.Text>

                <div style={{
                    background: '#f0f5ff',
                    border: '1px border #adc6ff',
                    borderRadius: '6px',
                    padding: '12px 16px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: 20
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <FileTextOutlined style={{ color: '#1890ff', fontSize: '18px' }} />
                        <div>
                            <div style={{ fontWeight: 500, color: '#262626' }}>Need a template?</div>
                            <div style={{ fontSize: '12px', color: '#595959' }}>Use our standard format for best results</div>
                        </div>
                    </div>
                    <a
                        href={SAMPLE_FILE}
                        download="SampleCancellation.csv"
                        style={{
                            color: '#1890ff',
                            fontWeight: 500,
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px',
                            cursor: 'pointer'
                        }}
                    >
                        <DownloadOutlined /> Download Sample
                    </a>
                </div>
            </div>

            <Spin spinning={loading} tip="Processing your file...">
                <Dragger {...props} style={{ padding: '20px', background: '#fafafa', borderRadius: '8px', border: '1px dashed #d9d9d9' }}>
                    <p className="ant-upload-drag-icon">
                        <CloudUploadOutlined style={{ color: '#1890ff', fontSize: '48px' }} />
                    </p>
                    <p className="ant-upload-text" style={{ fontSize: '16px', fontWeight: 500, color: '#262626', margin: '16px 0 8px' }}>
                        Click or drag file to this area to upload
                    </p>
                    <p className="ant-upload-hint" style={{ color: '#8c8c8c', fontSize: '13px' }}>
                        Support for a single upload. Supported formats: .csv, .xlsx
                    </p>
                </Dragger>
            </Spin>
        </Modal>
    );
};

export default BulkTrackingModal;
